import { render } from "./Receptions.vue?vue&type=template&id=06732b7a&scoped=true"
import script from "./Receptions.vue?vue&type=script&lang=js"
export * from "./Receptions.vue?vue&type=script&lang=js"

import "./Receptions.vue?vue&type=style&index=0&id=06732b7a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06732b7a"]])

export default __exports__